// ======================================================================
// File Name       : LoginContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { checkCertificateUsage, login } from '../actions/AuthAction';
import FormControlValidate from '../components/FormControlValidate';
import MessageView from '../components/MessageView';
import { BILLING_SYSTEM_REGISTER_FLAG_STATUS } from '../constants/EnterpriseConstants';
import { TOKEN } from '../constants/LocalStorageConstants';
import { LOGIN_TYPE } from '../constants/LoginConstant';
import { CHANGE_PASSWORD, ENTERPRISE_LIST, PASSWORD_RESET_REQUEST, SERVICE_LOGIN_LIST, SUPERUSER_PASSWORD_RESET_REQUEST, TOP_LIST } from '../constants/PathConstants';
import { HIDE_MESSAGE } from '../constants/actionTypes/message';
import { PAYMENT_URL, VALIDATE_TYPE } from '../constants/index';
import { getLoginUrl } from '../utils/AuthedUtils';
import { handleChangePageTitle, setGTMConfig } from '../utils/PageUtils';
import * as SessionStorageUtils from '../utils/SessionStorageUtils';
import * as ValidateUtils from '../utils/ValidateUtils';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginType: LOGIN_TYPE.USER_SERVICE,
      serviceId: '',
      loginId: '',
      password: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLoginBtn = this.handleLoginBtn.bind(this);
    this.changeLoginType = this.changeLoginType.bind(this);

  }
  componentWillMount() {
    setGTMConfig();
    window.appendCorsIframe();

    // Step8.0.3 START
    handleChangePageTitle();
    this.unlisten = this.props.history.listen(() => handleChangePageTitle());
    // Step8.0.3 END
  }

  // Step8.0.3 START  
  componentWillUnmount() {
    this.unlisten();
  }
  // Step8.0.3 END

  /**
   * handle text input change
   * @param {*} event
   */
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  /**
   * Check validate input
   */
  validForm() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  /**
   * handle login button
   */
  handleLoginBtn() {
    const valid = this.validForm();
    if (!valid) {
      return;
    }

    const { loginType, loginId, password } = this.state;
    const { dispatch } = this.props;
    const loginInfo = {
      loginType,
      loginId,
      password,
    };
    // #7303 START
    if (loginType === LOGIN_TYPE.USER_SERVICE) {
      loginInfo.serviceCd = this.state.serviceId;
      dispatch(checkCertificateUsage(loginInfo));
    } else {
      loginInfo.enterpriseCd = this.state.serviceId;
      dispatch(login(loginInfo));
    }
    // #7303 END
  }

  changeLoginType(){
    const { loginType } = this.state;
    if(this.refsToValidate && this.refsToValidate.length){
      this.refsToValidate.forEach((item) => {
        item.setState({errorVisible: false});
      });
    }
    this.props.dispatch({
      type: HIDE_MESSAGE,
    });
    this.setState({
      loginType:
        loginType === LOGIN_TYPE.SUPERUSER
          ? LOGIN_TYPE.USER_SERVICE
          : LOGIN_TYPE.SUPERUSER,
    })
  }

  render() {
    // sprint_20230418 #12 START
    const { loginType } = this.state;
    const {
      logined,
      passwordChangeFlag,
      loginedAsSuperUser,
      message,
      readOnlyFlag,
      contractEnterpriseBillingSystemRegisterFlag,
      location: { search },
      isOEMUser,
      token,
    } = this.props;
    this.refsToValidate = [];

    if (passwordChangeFlag) {
      return <Redirect to={CHANGE_PASSWORD} />;
    }

    if (logined) {
      SessionStorageUtils.save('loginId', this.state.loginId);
      // Step 9.0.0 START
      if (isOEMUser) {
        window.sendToken(token);
        window.location.href = getLoginUrl();
      } else {
        // sprint_20230508_#29 START
        // sprint_20230522_tma START
        if (
          ValidateUtils.isRedirectContractUrl(search) &&
          contractEnterpriseBillingSystemRegisterFlag ===
            BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED
        ) {
        // sprint_20230522_tma END
          window.location.href = PAYMENT_URL;
        } else {
          if (loginedAsSuperUser) {
            return <Redirect to={readOnlyFlag ? ENTERPRISE_LIST : SERVICE_LOGIN_LIST} />;
          }
          return <Redirect to={TOP_LIST} />;
        }
        // sprint_20230508_#29 END
      }
      // Step 9.0.0 END
    }
    // sprint_20230418 #12 END

    return (
      <Col className="container">
        <Col className="margin-top-20 max-width-650">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleLoginBtn();
            }}
            className="form-horizontal"
          >
            <Form.Group
              className={
                loginType === LOGIN_TYPE.SUPERUSER
                  ? "form-info form-enterprise"
                  : "form-info form-service"
              }
            >
              <Col sm={12} className="text-center font-weight-bold">
                <h1>
                  <strong>
                    {loginType === LOGIN_TYPE.SUPERUSER
                      ? "企業ログイン画面"
                      : "サービスログイン画面"}
                  </strong>
                </h1>
              </Col>
            </Form.Group>
            <Form.Group className="form-info form-group">
              <Col as={Form.Label} sm={3}>
                {loginType === LOGIN_TYPE.SUPERUSER
                  ? "企業コード"
                  : "サービスコード"}
              </Col>
              <Col sm={9}>
                <FormControlValidate
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  // sprint_20230403 #6 START
                  validateType={VALIDATE_TYPE.ID_INCLUDING_HYPHEN}
                  // sprint_20230403 #6 END
                  type="text"
                  label={
                    loginType === LOGIN_TYPE.SUPERUSER
                      ? "企業コード"
                      : "サービスコード"
                  }
                  name="serviceId"
                  maxLength={256}
                  value={this.state.serviceId}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info form-group">
              <Col as={Form.Label} sm={3}>
                ログインID
              </Col>
              <Col sm={9}>
                <FormControlValidate
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  label="ログインID"
                  // #7483 START
                  maxLength="256"
                  // #7483 END
                  type="text"
                  name="loginId"
                  value={this.state.loginId}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info form-group">
              <Col as={Form.Label} sm={3}>
                パスワード
              </Col>
              <Col sm={9}>
                <FormControlValidate
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  required
                  label="パスワード"
                  maxLength={256}
                  type="password"
                  name="password"
                  value={this.state.password}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Form.Group>
            <Row>
              <Col
                sm={{
                  span: 9,
                  offset: 3,
                }}
              >
                <Link
                  role="presentation"
                  to={{
                    pathname:
                      loginType === LOGIN_TYPE.SUPERUSER
                        ? SUPERUSER_PASSWORD_RESET_REQUEST
                        : PASSWORD_RESET_REQUEST,
                  }}
                >
                  パスワードを忘れた方はこちら
                </Link>
              </Col>
            </Row>
            <Col sm={12} className="text-center padding-left-right-clear">
              <MessageView
                message={message}
                onDismiss={() => {
                  this.props.dispatch({
                    type: HIDE_MESSAGE,
                  });
                }}
              />
            </Col>
            <Row className="margin-top-20">
              <Col sm={12} className="text-center">
                <Button type="submit">ログイン</Button>
              </Col>
            </Row>
            <Col className="margin-top-20">
              <Link
                to={{ search }} // sprint_20230508_#29
                onClick={() => this.changeLoginType()}
              >
                {loginType === LOGIN_TYPE.SUPERUSER
                  ? "サービス管理者の方はこちら"
                  : "SuperUserの方はこちら"}
              </Link>
            </Col>
          </Form>
        </Col>
      </Col>
    );
  }
}

LoginContainer.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => {
  const {
    logined,
    authedUser: {
      enterpriseCd,
      userInfo: { passwordChangeFlag },
      readOnlyFlag,
      contractEnterpriseBillingSystemRegisterFlag,
      isOEMUser,
      token,
    },
  } = state.authed;
  const { message } = state;
  const authedToken = token || localStorage.getItem(TOKEN);

  return {
    logined,
    passwordChangeFlag,
    loginedAsSuperUser: !!enterpriseCd,
    message,
    readOnlyFlag, // sprint_20230418 #12
    contractEnterpriseBillingSystemRegisterFlag, // sprint_20230522_tma
    //Step 9.0.0 START
    isOEMUser, 
    token: authedToken,
    //Step 9.0.0 END
  };
};

export default connect(mapStateToProps)(LoginContainer);
